<template>
    <div class="main">
        <ul>
            <li>
                <img v-for="(item, index) in images" :key="index" :src="item" alt="">
            </li>
        </ul>
    </div>
</template>

<script>
import config from "@/common/env.js"

export default {
    name: 'images',
    data() {
        return {
            images: [],
            
        }
    },
    created() {

    },
    mounted(){
        this.getFiles();
    },
    methods: {
        getImageUrl(url, type) {
            let str = type ? "/file/server/file" : "/file/server/decrypt/file";
            return `${config.baseUrl}${str}?path=${encodeURI(url)}`;
        },
        getFiles() {
            console.log(this.$route.query)
            let fileCode = this.$route.query.fileCode;
            this.$axios.get(`/file/server/certificate?fileCode=${fileCode}`).then(res => {
                let data = res.data;
                if (data.code == 0) {
                    var infos = data.data;
                    if(infos.length){
                        infos.forEach(item => {
                            this.images.push(this.getImageUrl(item));
                        })
                    }
                } else {
                    this.$message.error(data.msg);
                }
            })
        },
    }
}
</script>

<style lang="scss" scoped>
.main {
    width: 100%;
    // height: 100%;
    display: flex;
    align-items: center;

    ul {
        width: 100%;

        li {
            width: 100%;

            img {
                width: 100%;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// files.vue?1d1e3beb